<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">系統設定</h1>
        <p class="page-subtitle">管理系統各項功能配置和基礎數據</p>
      </div>
      <div class="header-right">
        <!-- 可扩展添加帮助/刷新等按钮 -->
      </div>
    </div>

    <div class="layout">
      <!-- 配置项展示区 -->
      <div class="settings-container">
        <!-- PC端网格布局（≥768px显示） -->
        <div class="pc-settings">
          <div class="settings-grid">
            <div
                class="setting-card"
                v-for="(item, index) in list"
                :key="index"
                @click="onClicked(item.path)"
            >
              <div class="card-icon">
                <i :class="getIconClass(index)"></i>
              </div>
              <div class="card-title">{{ item.title }}</div>
              <div class="card-action">
                <el-button type="text" icon="el-icon-arrow-right">
                  進入設定
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 移动端列表布局（<768px显示） -->
        <div class="mobile-settings">
          <div class="settings-list">
            <div
                class="setting-item"
                v-for="(item, index) in list"
                :key="index"
                @click="onClicked(item.path)"
            >
              <div class="item-icon">
                <i :class="getIconClass(index)"></i>
              </div>
              <div class="item-content">
                <div class="item-title">{{ item.title }}</div>
                <div class="item-desc">{{ getDescText(index) }}</div>
              </div>
              <div class="item-arrow">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [
        {
          title: '回報問題類別',
          path: '/setting/course-sales-statistics'
        },
        {
          title: '分校列表',
          path: '/setting/courseUsageAnalysisReport'
        },
        {
          title: '年級訂閱價格',
          path: '/setting/subscription-price'
        },
        {
          title: '學生平台教學圖片',
          path: '/setting/teaching-picture'
        },
        {
          title: '網頁常見問題',
          path: '/setting/common-problem'
        },
        {
          title: '幫助手冊',
          path: '/setting/common-problem2'
        },
        {
          title: '自動升級時間設定',
          path: '/setting/automatic-upgrade-time'
        },
      ]
    };
  },
  methods: {
    // 跳转配置页面
    onClicked(path) {
      this.$router.push({ path: path });
    },
    // 根据索引获取图标类名
    getIconClass(index) {
      const iconList = [
        'el-icon-s-comment',    // 回報問題類別
        'el-icon-office-building', // 分校列表
        'el-icon-money',        // 年級訂閱價格
        'el-icon-picture',      // 學生平台教學圖片
        'el-icon-question',     // 網頁常見問題
        'el-icon-document',     // 幫助手冊
        'el-icon-clock'         // 自動升級時間設定
      ];
      return iconList[index] || 'el-icon-setting';
    },
    // 根据索引获取描述文本
    getDescText(index) {
      const descList = [
        '管理問題回報的分類和處理流程',
        '維護分校基礎信息和配置',
        '設定不同年級的訂閱價格標準',
        '上傳和管理學生平台教學圖片',
        '配置網頁端常見問題解答內容',
        '編輯和維護系統幫助手冊',
        '設定用戶等級自動升級的時間規則'
      ];
      return descList[index] || '點擊進入詳細設定';
    }
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 22px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
    .page-subtitle {
      font-size: 14px;
      color: #6c757d;
      margin: 0;
    }
  }

  .header-right {
    display: flex;
    gap: 8px;
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 配置项容器样式 */
.settings-container {
  width: 100%;

  /* PC端网格布局 */
  .pc-settings {
    .settings-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 20px;

      .setting-card {
        background: #f8f9fa;
        border-radius: 8px;
        padding: 24px;
        border: 1px solid #e9ecef;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
          border-color: #166ea5;
        }

        .card-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: #e8f4f8;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 16px;

          i {
            font-size: 24px;
            color: #166ea5;
          }
        }

        .card-title {
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 12px;
        }

        .card-action {
          margin-top: auto;

          .el-button {
            color: #166ea5;
            font-size: 14px;
          }
        }
      }
    }
  }

  /* 移动端列表布局 */
  .mobile-settings {
    display: none;

    .settings-list {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .setting-item {
        background: #f8f9fa;
        border-radius: 8px;
        padding: 16px;
        border: 1px solid #e9ecef;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 12px;
        transition: all 0.2s ease;

        &:hover {
          border-color: #166ea5;
          background: #e8f4f8;
        }

        .item-icon {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #e8f4f8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;

          i {
            font-size: 18px;
            color: #166ea5;
          }
        }

        .item-content {
          flex: 1;

          .item-title {
            font-size: 16px;
            font-weight: 600;
            color: #1f2937;
            margin-bottom: 4px;
          }

          .item-desc {
            font-size: 12px;
            color: #6c757d;
            line-height: 1.4;
          }
        }

        .item-arrow {
          color: #999;
          flex-shrink: 0;
        }
      }
    }
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 12px;
  }

  .layout {
    //padding: 16px;
  }

  /* 隐藏PC布局，显示移动端布局 */
  .pc-settings {
    display: none;
  }
  .mobile-settings {
    display: block;
  }
}

/* 适配平板屏幕 */
@media (min-width: 769px) and (max-width: 1024px) {
  .layout {
    //padding: 20px;
  }

  .settings-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>